import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import AccountChangePrompt from '@/components/content/accountChangePrompt/main.vue'
import { useAccountChange } from '@teams/common/hooks/useAccountChange'

export default /*#__PURE__*/_defineComponent({
  __name: 'private',
  setup(__props) {

const { promptComponentType } = useAccountChange()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AccountChangePrompt, { key: _unref(promptComponentType) }))
}
}

})